import { Component, Input } from '@angular/core';
import { SectorHelper } from '../../helpers/sector.helper';

@Component({
  standalone: false,
  selector: 'app-tag',
  templateUrl: './tag.component.html',
})
export class TagComponent {
  @Input() sector: string;
  @Input() isActive: boolean;

  constructor(public sectorHelper: SectorHelper) {}
}
